import { QueryParams } from './types';

export const getSelectOptions = (
  arr: string[],
): { label: string; value: string }[] =>
  Array.isArray(arr) ? arr.map((v) => ({ label: v, value: v })) : [];

export const getStartEndTime = (value, query) => {
  const now = new Date();
  let startTime: string | undefined;
  let endTime: string | undefined = now.toISOString();
  switch (value) {
    case '5m':
      startTime = new Date(now.getTime() - 5 * 60 * 1000).toISOString();
      break;
    case '10m':
      startTime = new Date(now.getTime() - 10 * 60 * 1000).toISOString();
      break;
    case '30m':
      startTime = new Date(now.getTime() - 30 * 60 * 1000).toISOString();
      break;
    case '1h':
      startTime = new Date(now.getTime() - 60 * 60 * 1000).toISOString();
      break;
    case '4h':
      startTime = new Date(now.getTime() - 4 * 60 * 60 * 1000).toISOString();
      break;
    case '12h':
      startTime = new Date(now.getTime() - 12 * 60 * 60 * 1000).toISOString();
      break;
    case '1d':
      startTime = new Date(now.getTime() - 24 * 60 * 60 * 1000).toISOString();
      break;
    case '3d':
      startTime = new Date(
        now.getTime() - 3 * 24 * 60 * 60 * 1000,
      ).toISOString();
      break;
    case '7d':
      startTime = new Date(
        now.getTime() - 7 * 24 * 60 * 60 * 1000,
      ).toISOString();
      break;
    case 'custom':
      startTime = query.startTime;
      endTime = query.endTime;
      break;
    default:
      startTime = undefined;
  }

  return { startTime, endTime };
};

export const buildQuery = (params: QueryParams) => {
  const query: string[] = [];
  if (params.eventId)
    query.push(`eventId=${encodeURIComponent(params.eventId)}`);
  if (params.app) query.push(`app=${encodeURIComponent(params.app)}`);
  if (params.startTime)
    query.push(`startTime=${encodeURIComponent(params.startTime)}`);
  if (params.endTime)
    query.push(`endTime=${encodeURIComponent(params.endTime)}`);
  if (params.data) query.push(`data=${encodeURIComponent(params.data)}`);
  if (params.limit) query.push(`limit=${params.limit}`);
  return query.length ? `?${query.join('&')}` : '';
};
